import {React, useEffect, useRef} from "react";
import { Link, useLoaderData, useLocation } from "react-router-dom";
import { levelContentData } from "../Content/LevelContentData.js";
/*import { getUserRank } from "../../utils/permissions.js"; */
import '../Home/Home.css';
import { useTranslation } from "../../utils/hooks/translateHook.js";
import { useLevelContentData } from "../../utils/hooks/translateLevelContentDataHook.js";
import headerVideo from "../../images/video-hq-small.mp4";
import guestMain from "../../images/guest-1-420x300px.jpg";
import guestSmall from "../../images/guest-2-175px.jpg";
import Books from "../../images/icons/books.svg";
import Magnifier from "../../images/icons/magnifier.svg";
import Grad from "../../images/icons/professionalism.svg";
import courseArrow from "../../images/icons/course-arrow.svg";

const Home = ({ user }) => {
  const t = useTranslation();
  const translatedLevelContent = useLevelContentData();
  
  const isGuest = !user ||  !localStorage.getItem("token");
  const userLevel = isGuest ? 0 : user.subscriptionLevel;

  const userLevelContent = translatedLevelContent
    .slice()
    .sort((a, b) => b.level - a.level)
    .find((item) => userLevel>= item.level);

    console.log("🏠 Home loaded for user level:", user.subscriptionLevel);
    const lang = localStorage.getItem("language") || "en";

  

  return (
    <div className="home-section" key={lang}>
      <div className="home-section__layer">
        <div className="home-section__layer-video">
          <video className="home-section__bg-video" 
            src={headerVideo} 
            autoPlay
            loop
            muted
            playsInline
          />
          <section className="home-section__content" >
            <div className="home-section__contentwrap" >
              <h1 className="home-title" style={{ marginTop: "2rem" }}>
                {isGuest  ? t("welcomeToAcademy") : t("welcomeToAcademy")}
                
                {/* {isGuest
                ? `${t("welcomeToAcademy")}:  ${t(userLevelContent?.title || "")}`
                : t(userLevelContent?.title || "")} */}
              </h1>
           
              <p className="home-description">
              {isGuest
                ? t("exploreContent") : t("exploreContent") }
                {/* : t(userLevelContent?.description || "")} : sonrasi yukariya eklendi exploreContent olarak rank kalkti */}
              </p>
              {/* {!isGuest &&  ( 
              <p className="home-rank" >
                {t('currentRank')}: {t(getUserRank(user.subscriptionLevel).toUpperCase())}
              </p>
              )}   */}     

              <div className="home-button-container" >
                <Link to={isGuest ? "/upgrade": "/content"} className="home-content-button" >
                  { t("startLearning")}
                </Link>
              </div>
            </div>
          </section>
        </div>
        <div className="home-section__layer">
          <section name="sectionTwo" className="sectionTwo">
            <div className="sectionTwo-imgContainer">
              <img src={guestMain} className="regularImage" alt="A guy studying"/>
              <img src={guestSmall} className="miniImage" alt="A happy guy studying with his laptop"/>
            </div>
            <div className="sectionTwo-text">
              <h1>Our Courses Are <b style={{color: "#e57d2e"}}>For You</b> If:</h1>
              <ul>
                <li>
                  <div>
                    <img src={Books} alt="Books icon"/>
                    <p>You require <span className="highlight"> comprehensive knowledge </span> to enter a new field. </p>
                  </div>
                </li>
                <li>
                  <div>
                  <img src={Magnifier} alt="Magnifier Icon"/>
                  <p> You started learning but got lost in the sheer volume of <span className="highlight"> redundant information.</span> </p>
                  </div>
                </li>
                <li>
                  <div>
                    <img src={Grad} alt="Graduation cap icon"/>
                    <p>You are currently studying a subject but cannot reach the desired<span className="highlight"> level of professionalism.</span></p>
                  </div>  
                </li>
              </ul>
              
            </div>
          </section>
    
          <section name="sectionThree intro" className="sectionIntro"> 
                  <h1>We provide the <b>Path</b> for your <b>Education </b>journey</h1>
            <div name="grid" className="introGrid">
              <div className="gridPair">
                  <div name="gridImageItem" className="gridCell">
                    <img className="gridImageItem Item1"  />
                  </div>
                  <div className="gridCell ">
                      <p className="gridTextItem itemBox">
                        <strong>Build Knowledge</strong>
                        Deepen your understanding across multiple subjects and gain the essentials to strengthen your progress.
                      </p>
                  </div>
              </div>
              <div className="gridPair">
                <div name="gridImageItem 2" className="gridCell">
                  <img className="gridImageItem Item2"  />
                </div>              
                <div className="gridCell ">
                  <p className="gridTextItem 2 itemBox">
                    <strong>Put It Into Action</strong>
                    Apply what you learn through hands-on tasks, with expert support tailored to your progress.
                  </p>
                </div>
              </div>

              <div className="gridPair">
                <div className="gridCell">
                  <p className="gridTextItem 3 itemBox">
                    <strong>Find Your Track</strong>
                    Explore different programs and learning routes to discover what best fits your interests and goals.
                  </p>
                </div>
                <div name="gridImageItem 3" className="gridCell">
                  <img className="gridImageItem Item3" />
                </div>   
              </div>

              <div className="gridPair">
                <div className="gridCell">
                  <p className="gridTextItem 4 itemBox">
                    <strong>Keep Skills Current</strong>
                    Refresh and upgrade your existing knowledge to stay up to date and unlock new opportunities.
                  </p>
                </div>
                <div name="gridImageItem 4" className="gridCell">
                  <img className="gridImageItem Item4" />
                </div>   
              </div>

            </div>           
          </section>

          <section name="sectionThree" className="sectionThree">
            <h1>OUR COURSES</h1>
            <div name="coursesGrid" className="coursesGrid" >
              <div name="Pyhton" className="gridItem bg-gray bg python">
                <Link to="/courses#python">
                  <p className="grid-arrow"><img src={courseArrow}  alt="Arrow Pointing Upper Right corner"/></p>
                  <p className="gridElement"> <span>PYHTON</span></p>
                </Link>
              </div>
              
              <div name="VixAcademy" className="gridItem bg-gray bg vix">
                <Link to="/courses#fundamentals">
                  <p className="grid-arrow"><img src={courseArrow} alt="Arrow Pointing Upper Right corner" /></p>
                  <p className="gridElement"> <span>VIX ACADEMY</span></p>
                </Link>
              </div>
              <div name="Java Script" className="gridItem bg-orange bg js">
                <Link to="/courses#javascript">
                  <p className="grid-arrow"><img src={courseArrow} alt="Arrow Pointing Upper Right corner" /></p>
                  <p className="gridElement"> <span>JAVA SCRIPT</span></p>
                </Link>
              </div>
              <div name="HTML & CSS" className="gridItem bg-orange bg htmlcss">
                <Link to="/courses#htmlcss">
                  <p className="grid-arrow"><img src={courseArrow} alt="Arrow Pointing Upper Right corner" /></p>
                  <p className="gridElement"> <span>HTML & CSS</span></p>
                </Link>
              </div>
              <div name="SocialMediaMarketing" className="gridItem bg-gray bg smm">
                <Link to="/courses#smm">
                  <p className="grid-arrow"><img src={courseArrow} alt="Arrow Pointing Upper Right corner" /></p>
                  <p className="gridElement"> <span>SOCIAL MEDIA MARKETING</span></p>
                </Link>
              </div>
              <div name="SEO" className="gridItem bg-gray bg seo">
                <Link to="/courses#seo">
                  <p className="grid-arrow"><img src={courseArrow} alt="Arrow Pointing Upper Right corner" /></p>
                  <p className="gridElement"> <span>SEO</span></p>
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Home;


/*home.js a gorselli welcome yazisini alacagiz */
/* 
App.js = the skeleton that wraps everything and connects routes
Home.jsx = the content shown at / based on the user
LevelContent.jsx = the full detailed training/resources they’ve unlocked
 */